<template>
	<div class="form-group fg-line">
		<div class="fg-line form-group inline" style="width: 100%">
			<select :value="dumby" v-on:input="addOption($event.target.value)" class="form-control" :disabled="disabled"
				required>
				<option :value="dumby" disabled>{{ placeholder_caption }}</option>
				<option v-for="option in option_list" :value="option[value_field]"
					:disabled="selected_option_values.some(selectedValue => selectedValue == option[value_field])">
					{{ option[caption_field] }}
				</option>
			</select>
		</div>

		<div v-if="selected_options">
			<ul class="option-list">
				<li v-for="option in selected_options">
					<button type="button" class="text-gray-drk" @click="removeOption(option[value_field])"
						tabindex="-1">
						<i class="fa fa-close" style="color:#f32c1e" aria-hidden="true"></i>
					</button>
					{{ option[caption_field] }}
				</li>
			</ul>
		</div>
	</div>
</template>

<style lang="scss">
@import '../../sass/_global_variables.scss';

.option-list {
	list-style: none;
	padding-left: 0px;
}
</style>

<script type="text/ecmascript-6">
export default {
	name: "multi-select-ex",
	props: {
		option_list: {
			type: Array,
			default: function () {
				return [];
			}
		},
		selected_option_values: {
			type: Array,
			default: function () {
				return [];
			}
		},
		placeholder_caption: { default: 'Select Option' },
		value_field: { default: 'id' },
		caption_field: { default: 'caption' },
		limit: { default: 0 },
		label: { type: String, default: '' },
		disabled: { default: false }
	},

	data: function () {
		return {
			// We need to have this 'dumby' value because, in our prod versions of Vue, null is not recognized as
			// a valid value and it will auto change to the first option on the list.
			// This confused users, thinking they had selected a valid sample type, yet weren't allowed to continue.
			// For some reason, inlining the literal string as a value in the html also caused this behavior.
			dumby: 'dumby'
		};
	},

	methods: {
		addOption(optionValue) {
			if ((this.limit > 0) && (this.selected_option_values.length >= this.limit)) {
				var msg = 'You have reached the limit';
				if (this.label) msg += ' for ' + this.label;
				msg += '.';
				sweetAlert('', msg, 'warning');
				return;
			}

			if (!this.selected_option_values.includes(optionValue)) {
				this.$emit('save', this.selected_option_values.concat([optionValue]));
			}
		},

		removeOption(optionValue) {
			this.$emit('save', this.selected_option_values.filter(selectedValue => selectedValue != optionValue));
		}
	},

	computed: {
		selected_options() {
			return this.option_list.filter(option => {
				return this.selected_option_values.some(selectedValue => selectedValue == option[this.value_field]);
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// multi-select-ex.vue?4ad4767f